// 客户端业务码与服务端保持同一分段：11xxxx 为通用客户端错误，12xxxx 为模型调用错误。
export const CLIENT_BUSINESS_CODE = {
  SUCCESS: 0,
  RESOURCE_NOT_FOUND: 110001,
  INVALID_REQUEST: 110002,
  UNAUTHORIZED: 110003,
  TOO_MANY_REQUESTS: 110004,
  INTERNAL_ERROR: 110006,
  MOON_BALANCE_INSUFFICIENT: 120001,
  MODEL_STREAM_UNSUPPORTED: 120002,
  MODEL_ACCESS_DENIED: 120003,
  MODEL_USAGE_EXHAUSTED: 120004,
  MODEL_CROWDED: 120005,
  MODEL_GATEWAY_REQUEST: 121001,
  MODEL_GATEWAY_TIMEOUT: 121002,
  MODEL_GATEWAY_CANCELED: 121003,
  MODEL_GATEWAY_NETWORK: 121004,
  MODEL_GATEWAY_READ: 121005,
  MODEL_UPSTREAM_AUTH: 121006,
  MODEL_UPSTREAM_NOT_FOUND: 121007,
  MODEL_UPSTREAM_TIMEOUT: 121008,
  MODEL_UPSTREAM_RATE_LIMIT: 121009,
  MODEL_UPSTREAM_SERVER: 121010,
  MODEL_UPSTREAM_REJECTED: 121011,
  MODEL_RESPONSE_TOO_LARGE: 121012,
  MODEL_INVALID_JSON: 121013,
  MODEL_INVALID_RESPONSE: 121014,
  MODEL_EMPTY_CONTENT: 121015,
  MODEL_GATEWAY_UNKNOWN: 121016,
  MODEL_PERSISTENCE_FAILED: 122001
} as const;

// 浏览器本地传输失败没有服务端业务响应，使用独立 19xxxx 段供游戏统一处理。
export const RUNTIME_TRANSPORT_CODE = {
  REQUEST_CANCELED: 190001,
  NETWORK_UNREACHABLE: 190002,
  REQUEST_FAILED: 190003,
  RESPONSE_READ_FAILED: 190004,
  HTTP_ERROR: 190005
} as const;

export type ClientBusinessCode = typeof CLIENT_BUSINESS_CODE[keyof typeof CLIENT_BUSINESS_CODE]
  | typeof RUNTIME_TRANSPORT_CODE[keyof typeof RUNTIME_TRANSPORT_CODE];
